import React from 'react'
import { editAdminProfileInfo } from '../../../Apis/profileApi';
import Form from './Form'

export default function EditAccountSettings() {
    // onsubmit
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        data.append("_method", "patch");
        return await editAdminProfileInfo(data).then(res => {
            return 'done';          
        }).catch(err => {
            return err.response.data.errors;
        })
    };

    return (
        <Form onSubmit={onSubmit}></Form>
    )
}
